import { Select, Input } from "antd";
import { t } from "i18next";
import { BackIcon } from "../../../asset";
import React, { useState } from 'react';
import style from './userPage.module.css';
import ConfirmationModal from "../../../component/modal/ConfirmationModal";
import SuccessModal from "../../../component/modal/SuccessModal";
import { useNavigate } from "react-router";
import { ROUTES } from "../../../constant/routeConstant";
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import * as InvitationServices from '../../../service/admin/User/InvitationServices';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { makeListDDL, validateSubmit } from "../../../util/Util";
import { validasiinvitation } from "./validasiInvitation";
import NotifAddSuccess from "../../../component/modal/NotifAddSuccess";
import NotifFailedSaved from "../../../component/modal/NotifFailedSaved";
import SelectSearch from "../../../component/input/SelectSearch";

export default function UserSendInvitation() {
    const { token } = useSelector((state) => state.auth);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [form, setForm] = useState({});
    const [listRole, setListRole] = useState([]);
    const [listDataGroup, setListDataGroup] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [filterRole, setFilterRole] = useState('updated_at desc');

    const [error, setError] = useState([]);
    const [err, setErr] = useState("");
    const [failedModalOpen, setFailedModalOpen] = useState(false)
    const [messageFailed, setMessageFailed] = useState('');
    const [successModalOpen, setSuccessModalOpen] = useState(false)
    const [messagesSuccess, setMessagesSuccess] = useState('');

    const [invitationModalOpen, setInvitationModalOpen] = useState(false);

    const [roleKeyword, setRoleKeyword] = useState('')
    const [dataGroupKeyword, setDataGroupKeyword] = useState('')

    const [roleListPage, setRoleListPage] = useState(1)
    const [dataGroupListPage, setDataGroupListPage] = useState(1)

    const [dropdownListLoading, setDropdownListLoading] = useState(false)

    const backToInvitationList = () => {
        navigate(ROUTES.INVITATION.LIST)
    }

    const invite = async () => {
        const { status, message } = await InvitationServices.insert(token, null, form, null, dispatch);

        if (status) {
            setInvitationModalOpen(false);
            setSuccessModalOpen(true);
            setMessagesSuccess(message);
        } else {
            setInvitationModalOpen(false);
            setFailedModalOpen(true);
            setMessageFailed(message);
        }
    }

    const _onSend = () => {
        let errors = {};

        let keys = {
            email: form.email,
            role_id: form.role_id,
            data_group_id: form.data_group_id
        }

        for (const key in keys) {
            const option = validasiinvitation(key, keys[key], t);
            const currentError = option;
            errors = { ...currentError, ...errors };
        }
        setError(errors);
        if (validateSubmit(errors)) {
            setInvitationModalOpen(true);
        } else {
            setInvitationModalOpen(false);
        }
    }

    const getListRole = async (page, limit, keyword = '', flag = 'list') => {
        const { ok, list } = await InvitationServices.listRole(token, null, page, limit, dispatch, keyword);

        if (ok && list?.length > 0) {

            if (flag === 'list') {
                if (listRole.length === 0) {
                    setListRole(list);
                } else {
                    let tempListRole = [...listRole]
                    list?.map(item => tempListRole.push(item))
                    setListRole(tempListRole)
                }
                setDropdownListLoading(false)
            } else if (flag === 'searchList') {
                setListRole(list)
            }
        }

    }

    const getListDataGroup = async (page, limit, keyword = '', flag = 'list') => {
        const { ok, list } = await InvitationServices.listDataGroup(token, null, page, limit, dispatch, keyword);

        if (ok && list?.length > 0) {
            if (flag === 'list') {
                if (listDataGroup.length === 0) {
                    setListDataGroup(list);
                } else {
                    let tempListDataGroup = [...listDataGroup]
                    list?.map(item => tempListDataGroup.push(item))
                    setListDataGroup(tempListDataGroup)
                }
                setDropdownListLoading(false)
            } else if (flag === 'searchList') {
                setListDataGroup(list)
            }
        }
    }

    useEffect(() => {
        Promise.all([
            getListRole(page, limit),
            getListDataGroup(page, limit)
        ]);

    }, [page, limit]);

    const _onChange = (evt, namespace) => {
        setErr("")
        if (namespace === 'email') {
            let eror = validasiinvitation('email', evt.target.value, t);

            setError({ ...error, ...eror });
            setForm((prevsValue) => {
                return {
                    ...prevsValue,
                    email: evt.target.value
                }
            });
        }
    }

    const _onChangeSelect = (evt, namespace) => {
        setErr("")
        let eror = validasiinvitation(namespace, evt, t);

        setError({ ...error, ...eror });
        setForm((prevsValue) => {
            return {
                ...prevsValue,
                [namespace]: evt
            }
        });
    }

    const _onOkSuccesAdd = () => {
        setSuccessModalOpen(false)
        navigate(ROUTES.INVITATION.LIST)
    }

    const onScroll = (event, namespace) => {
        let target = event.target
        switch (namespace) {
            case 'role':
                if (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight || (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight + 1) && !dropdownListLoading) {
                    getListRole(roleListPage + 1, 10, roleKeyword)
                    setRoleListPage(roleListPage + 1)
                    target.scrollTo(0, target.scrollHeight);
                }
                break;

            case 'data_group':
                if (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight || (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight + 1) && !dropdownListLoading) {
                    getListDataGroup(dataGroupListPage + 1, 10, dataGroupKeyword)
                    setDataGroupListPage(dataGroupListPage + 1)
                    target.scrollTo(0, target.scrollHeight);
                }
                break;
            default:
                break;
        }
    }

    const onSearchDDS = (value, namespace) => {
        switch (namespace) {
            case 'role':
                setRoleKeyword(value)
                if (value.length >= 3 || value === '') {
                    getListRole(1, 10, value, 'searchList')
                }
                setRoleListPage(1)
                break;

            case 'data_group':
                setDataGroupKeyword(value)
                if (value.length >= 3 || value === '') {
                    getListDataGroup(1, 10, value, 'searchList')
                }
                setDataGroupListPage(1)
                break;

            default:
                break;
        }
    }

    return (
        <div className='p-[24px] flex flex-col gap-[24px]'>

            <ConfirmationModal
                isOpen={invitationModalOpen}
                onOk={() => invite()}
                onCancel={() => setInvitationModalOpen(false)}
                closable={false}
                width={440}
                className={style.modalContainer}
                okText="Yes, Send Invitation"
                title="Send Invitation?"
                description={`Are you sure want to send invitation to ${form?.email}?`}
            />

            {/* <NotifAddSuccess
                visible={successModalOpen}
                menu={form?.email}
                action={_onOkSuccesAdd}
            /> */}
            <NotifFailedSaved
                visible={failedModalOpen}
                message={messageFailed}
                action={() => { setFailedModalOpen(false) }}
            />
            <SuccessModal
                isOpen={successModalOpen}
                onOk={_onOkSuccesAdd}
                closable={false}
                width={280}
                className={style.successModal}
                okText="Ok"
                title="Success"
                description="Your invitation already sent"
            />

            <Breadcumbs
                jmlLevel={5}
                menuLevel1={`Admin`}
                menuLevel2={`User Management`}
                menuLevel3={`User`}
                menuLevel4={`Invitation`}
                menuLevel5={`Send Invitation`}
            />

            <div className="flex items-center gap-[22px] cursor-pointer w-fit" onClick={() => backToInvitationList()}>
                <img src={BackIcon} alt="back-icon" />
                <h1 className='font-sans-bold text-2xl' id='title'>{t("USER_SEND_INVITATION:TITLE")}</h1>
            </div>

            <div className="border-[#DDDDDD] bg-white-100 rounded-[10px] border-[1px] px-[30px] py-[24px]">
                <h3 className="font-roboto font-bold mb-[16px] text-lg">{t("USER_SEND_INVITATION:TITLE")}</h3>

                <div className="flex flex-col gap-[16px]">
                    <div className="flex flex-col">
                        <label htmlFor="emailField" className="font-roboto font-bold text-md">{t("USER_SEND_INVITATION:EMAIL_FIELD")}</label>
                        <Input
                            style={{ width: 350, borderRadius: '6px', fontSize: 20 }}
                            className='mt-[8px]'
                            size='large'
                            value={form.email}
                            onChange={(evt) => { _onChange(evt, 'email') }}
                            placeholder={t("USER_SEND_INVITATION:EMAIL_FIELD_PLACEHOLDER")}
                        />
                    </div>
                    <div className="text-red-100 -mt-2">
                        {err ? err : error?.email}
                    </div>
                    <div className="flex flex-col">
                        <label htmlFor="role" className="font-roboto font-bold text-md">{t("USER_SEND_INVITATION:ROLE_FIELD")}</label>
                        {
                            listRole?.length !== 0 ?

                                <SelectSearch size="large" onScroll={(event) => onScroll(event, 'role')} keyword={roleKeyword} onChange={(value) => onSearchDDS(value, 'role')} onSelect={(value) => _onChangeSelect(value, 'role_id')} width={350} options={listRole} loading={dropdownListLoading} defaultValue={""} placeholder={"Select role"} status={error?.role_id ? 'error' : null} />

                                :

                                null
                        }
                    </div>
                    <div className="text-red-100 -mt-2">
                        {err ? err : error?.role_id}
                    </div>
                    <div className="flex flex-col">
                        <label htmlFor="dataGroup" className="font-roboto font-bold text-md">{t("USER_SEND_INVITATION:DATA_GROUP_FIELD")}</label>
                        {
                            listDataGroup?.length !== 0 ?

                                <SelectSearch size="large" onScroll={(event) => onScroll(event, 'data_group')} keyword={dataGroupKeyword} onChange={(value) => onSearchDDS(value, 'data_group')} onSelect={(value) => _onChangeSelect(value, 'data_group_id')} width={350} options={listDataGroup} loading={dropdownListLoading} defaultValue={""} placeholder={"Select data group"} status={error?.data_group ? 'error' : null} />

                                :

                                null
                        }
                    </div>
                    <div className="text-red-100 -mt-2">
                        {err ? err : error?.data_group_id}
                    </div>
                </div>
            </div>
            <div className="flex flex-row-reverse justify-start gap-[16px]">
                <button className="bg-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-white-100 font-sans text-[18px]" onClick={_onSend}>
                    {t("USER_SEND_INVITATION:SEND")}
                </button>
                <button onClick={()=>navigate(ROUTES.INVITATION.LIST)} className="border-[2px] border-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-[#CF0000] font-sans text-[18px]">
                    {t("USER_SEND_INVITATION:CANCEL")}
                </button>
            </div>

        </div>
    )
}
